const deviceAuthMessages = {
  'deviceAuth.title': '認証コード入力',
  'deviceAuth.description': '管理者から受領した認証コードを入力してください。',
  'deviceAuth.expiry': '認証コードの有効期限は発行から168時間です。',
  'deviceAuth.reissueLink': '認証コードを再発行する',
  'deviceAuth.activateButton': '認証する',
  'deviceAuth.invalidCode': '入力内容に誤りがあります。',
};

export default deviceAuthMessages;
